import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Import Bootstrap JS
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Inicjalizacja aplikacji Vue
const app = createApp(App);

// Używanie routera i store
app.use(router);
app.use(store);

// Montowanie aplikacji
app.mount("#app");
